module.exports = __webpack_public_path__ + "img/cyprus.a0053fe6.png";